import React, {Component} from "react";
import TableBody from "../../common/TableBody";

import DataResponse from "../../common/DataResponse";
import _ from "lodash";

class TranscriptSemesterTable extends Component {
    state = {
        data: [],
        summary: [],
        title: ''
    };

    componentDidMount = () => {
        const {data, summary, title} = this.props;

        this.setState({data: data?.data || data, summary: data?.summary || summary, title});
    };


    render() {
        const {data, summary, title} = this.state;
        const {columns} = this.props;

        return (
            <div style={{width: "100%", display: "grid", gridTemplateRows: "auto 60px"}} className="white-background-with-border">
                <div style={{position: "relative", borderLeft: "60px solid white",}}>
                    <h3 style={{
                        color: "var(--blue)",
                        textAlign: "center",
                        position: "absolute",
                        top: "30px",
                        fontSize: "0.9em",
                        left: "20px",
                        marginLeft: "-40px",
                        transform: "rotate(90deg)",
                        transformOrigin: "0 0",
                        letterSpacing: "2px",
                        textTransform: "uppercase"
                    }}>{title}</h3>
                    <div className="content">
                        <div className="print-table-area transcript-table-area">
                            <table>
                                {/* Table Header */}
                                <thead>
                                <tr>
                                    {columns &&
                                        columns.map(({key, path, label}) => (
                                            <th key={key || path}>
                                                {label}
                                            </th>
                                        ))}
                                </tr>
                                </thead>


                                {/* Table Body */}
                                <tbody>{data?.subjects && data?.subjects?.map((item, i) => {
                                    return (<tr key={i} className={"transcript-subject-row"}>
                                        {columns && columns.map((column) => <td
                                            key={item.id + (column.path || column.key)}>{_.get(item, column.path)}</td>)}
                                    </tr>)
                                })}</tbody>


                                {/* Table Footer */}
                                {/*<tfoot>*/}
                                {/*<tr>*/}
                                {/*    {summary && columns &&*/}
                                {/*        columns.map((column) => (*/}
                                {/*            <td key={summary.id + (column.path || column.key)}>*/}
                                {/*                {((s, c) => (c.path === "subject_code") ? "TOTAL" : _.get(s, c.path))(summary, column)}*/}
                                {/*            </td>*/}
                                {/*        ))}*/}
                                {/*</tr>*/}
                                {/*</tfoot>*/}
                            </table>
                        </div>
                    </div>
                </div>
                <div style={{
                    display: "grid",
                    gridTemplateColumns: "70px auto 70px 70px 70px  70px",
                    textAlign: "center",
                    marginLeft: "60px",
                    paddingTop: "20px",
                    paddingBottom: "20px",
                }} className="transcript-table-summary">
                    <p style={{fontSize: "12px", fontWeight: "bold", color: "var(--dark-gray)", paddingLeft: "10px", paddingRight: "10px"}}>TOTAL</p>
                    <p></p>
                    <p style={{fontSize: "12px", fontWeight: "bold", color: "var(--dark-gray)"}}>{summary.credits}</p>
                    <p style={{fontSize: "12px", fontWeight: "bold", color: "var(--dark-gray)"}}>{summary.total}</p>
                    <p></p>
                    <p style={{fontSize: "12px", fontWeight: "bold", color: "var(--dark-gray)"}}>{summary.GPA}</p>
                </div>
            </div>
        );
    }
}

export default TranscriptSemesterTable;
